import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {FormGroup} from '@angular/forms';
import {ReflexiveRestModel} from '../../reflexive-model/reflexive-rest-model';
import {TranslateService} from '@ngx-translate/core';
import {FieldDefinition} from '../../reflexive-model/field-definition';

@Component({
  selector: 'app-gelios-object-field',
  templateUrl: './gelios-object-field.component.html',
  styleUrls: ['./gelios-object-field.component.scss'],
})
export class GeliosObjectFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  @HostBinding('class.form__object-field') classFormAndButtonsContainer = true;
  @Input() fieldLabel: string;
  childFormGroup: FormGroup = null;

  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }

  showChildFormGroup(model: ReflexiveRestModel, fieldName: string): boolean {
    return model.fields[fieldName] &&
      (!model.fields[fieldName].isVisible || model.fields[fieldName].isVisible(this.childFormGroup));
  }

  showFieldGroup(fieldDefinition: FieldDefinition): boolean {
    switch (fieldDefinition.type) {
      case 'group':
        return fieldDefinition.groupContents.some(nestedFieldDefinition => this.showFieldGroup(nestedFieldDefinition));
      case 'field':
        return this.showChildFormGroup(this.model.fields[this.fieldName].value, fieldDefinition.name);
    }
  }

  ngOnInit() {
    super.ngOnInit();
    this.childFormGroup = this.formGroup.controls[this.fieldName] as FormGroup;
  }
}
